import { render } from "./CallbackPage.vue?vue&type=template&id=1ddfe1eb&scoped=true"
import script from "./CallbackPage.vue?vue&type=script&lang=js"
export * from "./CallbackPage.vue?vue&type=script&lang=js"

import "./CallbackPage.vue?vue&type=style&index=0&id=1ddfe1eb&scoped=true&lang=scss"

import exportComponent from "/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ddfe1eb"]])

export default __exports__